<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-signup></app-breadcrumb-signup>
    <app-signup-section></app-signup-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
